import { EAuthenticateError, EAuthenticateStatus, ECheckEmailStatus } from '../../../../types/authentication';
import { EActiveFlow } from '../../../../types/flow';
import { ERegisterErrorType, ERegisterStatus } from '../../../../types/registration';
import { isValidLogin } from '../../../../utils/validation';
export function isFormSubmitting(state) {
  var activeFlow = state.activeFlow,
    authentication = state.authentication,
    registration = state.registration;
  if (activeFlow === EActiveFlow.Registration) {
    return registration.register.status === ERegisterStatus.Loading || registration.register.status === ERegisterStatus.Succeed;
  } else if (activeFlow === EActiveFlow.Authentication) {
    return authentication.authenticate.status === EAuthenticateStatus.Loading || authentication.authenticate.status === EAuthenticateStatus.Succeed;
  } else {
    return authentication.checkEmail.status === ECheckEmailStatus.Loading;
  }
}
export function loginSelector(state) {
  return state.login;
}
export function hasLoginErrorSelector(state) {
  var activeFlow = state.activeFlow,
    authentication = state.authentication,
    registration = state.registration;
  if (activeFlow === EActiveFlow.Registration) {
    return registration.register.error !== undefined && registration.register.errorType === ERegisterErrorType.Email;
  } else if (activeFlow === EActiveFlow.Authentication) {
    return authentication.authenticate.error !== undefined && authentication.authenticate.errorType === EAuthenticateError.Common;
  } else {
    return authentication.checkEmail.error !== undefined;
  }
}
export function isLoginInvalidSelector(state) {
  var login = state.login;
  return login === '' || login !== '' && !isValidLogin(login);
}
export function loginErrorSelector(state) {
  if (!hasLoginErrorSelector(state)) {
    return undefined;
  }
  var activeFlow = state.activeFlow,
    registration = state.registration,
    authentication = state.authentication;
  if (activeFlow === EActiveFlow.Registration) {
    return registration.register.error;
  } else if (activeFlow === EActiveFlow.Authentication) {
    return authentication.authenticate.error;
  } else {
    return authentication.checkEmail.error;
  }
}
export function passwordSelector(state) {
  return state.authentication.password;
}
export function hasPasswordErrorSelector(state) {
  return state.registration.register.error !== undefined && state.registration.register.errorType === ERegisterErrorType.Password;
}
export function passwordErrorSelector(state) {
  return hasPasswordErrorSelector(state) ? state.registration.register.error : undefined;
}
export function isPasswordInvalidSelector(state) {
  return state.authentication.password === '';
}
export function isProfessionalUserSelector(state) {
  return state.registration.isProfessionalUser;
}